import { useState } from 'react';
import MuiLinkify from 'material-ui-linkify';
import { Typography, Link as MuiLink, type TypographyProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Clamp } from '../Clamp';

const useStyles = makeStyles({ name: 'Description' })({
  typography: {
    overflowX: 'hidden',
    whiteSpace: 'pre-wrap',
  },
});

interface DescriptionProps extends TypographyProps {
  readonly children: React.ReactNode;
  readonly lines?: number;
}

export const Description: React.FC<DescriptionProps> = ({
  children, className = '', lines, ...typographyProps
}) => {
  const { classes, cx } = useStyles();
  const [open, setOpen] = useState(false);

  if (lines && !open) {
    return (
      <Clamp
        lines={lines}
        className={cx(classes.typography, className)}
        overflowNode={(
          <>
            &hellip;

            {' '}

            <MuiLink
              onClick={() => setOpen(true)}
            >
              Show all
            </MuiLink>
          </>
        )}
        {...typographyProps}
      >
        {children}
      </Clamp>
    );
  }

  return (
    <Typography
      className={cx(classes.typography, className)}
      {...typographyProps}
    >
      <MuiLinkify
        hostnameOnly
        LinkProps={{
          color: 'primary',
          target: '_blank',
          rel: 'noopener noreferrer',
        }}
      >
        {children}
      </MuiLinkify>
    </Typography>
  );
};
